"use client";
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; 

// 1️⃣ استيراد الأيقونات من lucide-react
import { 
  Globe, 
  Mail, 
  Phone, 
  HelpCircle, 
  ArrowUpLeft,
  ArrowLeft,
  CheckCircle2,
  Calendar,
  ChevronDown,
  ChevronUp,
  Sparkles
} from 'lucide-react';

// 2️⃣ استيراد أيقونات السوشيال ميديا والمتاجر من react-icons
import { 
  FaFacebookF, 
  FaInstagram, 
  FaYoutube, 
  FaWhatsapp,
  FaGooglePlay,
  FaApple 
} from 'react-icons/fa';
import { usePathname } from 'next/navigation';

export default function FeaturedServices() {
  const [isExpanded, setIsExpanded] = useState(false);
  const res = usePathname();
  console.log(res);

  const contactLinks = [
    {
      id: 1,
      label: "منصة ميني ماني الإلكترونية",
      value: "minimoney.laserjet.com.eg",
      href: "https://minimoney.laserjet.com.eg",
      icon: <Globe className="w-5 h-5 text-[#004aad]" />
    },
    {
      id: 2,
      label: "البريد الإلكتروني للدعم",
      value: "minimoney@laserjet.com.eg",
      href: "mailto:minimoney@laserjet.com.eg",
      icon: <Mail className="w-5 h-5 text-[#004aad]" />
    },
    {
      id: 3,
      label: "رقم الخط الساخن والخدمة",
      value: "01004331113",
      href: "tel:01004331113",
      icon: <Phone className="w-5 h-5 text-[#004aad]" />
    },
    {
      id: 4,
      label: "مركز المساعدة الفورية",
      value: "help.laserjet.com.eg",
      href: "https://help.laserjet.com.eg",
      icon: <HelpCircle className="w-5 h-5 text-[#004aad]" />
    }
  ];

  const socialLinks = [
    { id: 1, name: "فيسبوك", href: "https://www.facebook.com/laserjet.com.eg", icon: <FaFacebookF className="w-5 h-5" />, color: "bg-[#3b5998] text-white border-transparent hover:scale-105" },
    { id: 2, name: "واتساب المباشر", href: "https://wa.me/+201004331113", icon: <FaWhatsapp className="w-5 h-5" />, color: "bg-[#25D366] text-white border-transparent hover:scale-105" },
    { id: 3, name: "إنستغرام", href: "https://www.instagram.com/laserjet.com.eg/", icon: <FaInstagram className="w-5 h-5" />, color: "bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] text-white border-transparent hover:scale-105" },
    { id: 4, name: "قناة واتساب", href: "https://whatsapp.com/channel/0029Va23H37GufIsQw29xG0a", icon: <FaWhatsapp className="w-5 h-5" />, color: "bg-[#25D366] text-white border-transparent hover:scale-105" },
    { id: 5, name: "يوتيوب", href: "https://www.youtube.com/@laserjet2458", icon: <FaYoutube className="w-5 h-5" />, color: "bg-[#ff0000] text-white border-transparent hover:scale-105" },
  ];

  const features = [
    { title: "مرونة في فترات السداد", desc: "اختر خطة التقسيط التي تناسبك من بين مجموعة واسعة تبدأ من 6 أشهر وتصل حتى 60 شهراً." },
    { title: "إجراءات ميسرة وسريعة", desc: "سهولة تامة في التعاقد لضمان حصولك على منتجاتك دون أي تعقيدات إدارية." },
    { title: "تغطية شاملة للمنتجات", desc: "الخدمة متاحة لكافة الأجهزة الإلكترونية والأجهزة المنزلية المتاحة عبر منصة LaserJet." },
    { title: "تخطيط مالي أفضل", desc: "نظّم مدفوعاتك الشهرية بما يتوافق تماماً مع دخلك بفضل خيارات السداد المتعددة." },
    { title: "متابعة ودعم مباشر", desc: "سهولة الوصول لمسؤولي الخدمة للاستفسار عن تفاصيل أقساطك أو تعديل خطط السداد." }
  ];

  const installmentPlans = ["6 أشهر", "12 شهراً", "24 شهراً", "36 شهراً", "48 شهراً", "60 شهراً"];

  return (
    <motion.section 
      initial={{ y: 30 }} 
      whileInView={{ opacity: 1, y: 0 }} 
      viewport={{ once: true, margin: "-100px" }} 
      transition={{ duration: 0.6, ease: "easeOut" }} 
      className="w-full bg-gradient-to-br from-[#f0f5fa] via-[#f7f9fc] to-[#e8f0fe] relative py-12 md:py-24 px-4 md:px-8 font-sans overflow-hidden min-h-screen flex items-center justify-center"
      dir="rtl"
    >
      {/* ─── الخلفية التقنية الناعمة ─── */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#004aad05_1px,transparent_1px),linear-gradient(to_bottom,#004aad05_1px,transparent_1px)] bg-[size:36px_36px]" />
        
        <motion.div 
          animate={{ x: [0, 30, 0], y: [0, -30, 0] }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
          className="absolute -top-20 -right-20 w-[500px] h-[500px] bg-[#004aad]/10 rounded-full blur-3xl"
        />
        <motion.div 
          animate={{ x: [0, -40, 0], y: [0, 40, 0] }}
          transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-0 -left-20 w-[450px] h-[450px] bg-[#00d2ff]/10 rounded-full blur-3xl"
        />
      </div>

      <div className="max-w-7xl mx-auto w-full relative z-10">
        
        {/* العناوين الرئيسية للسكشن */}
        <div className="flex justify-between items-center mb-8 md:mb-16 border-r-4 border-[#004aad] pr-5">
          <div>
            <span className="text-xs font-bold text-[#004aad] tracking-widest uppercase mb-1 block">المنصات الرقمية</span>
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 tracking-tight">خدماتنا المميزة</h2>
            <p className="text-xs md:text-sm text-gray-500 mt-2 font-medium">اكتشف أحدث المنصات والخدمات الرقمية المتكاملة لحلول ذكية</p>
          </div>
        </div>

        {/* تقسيم الشاشة */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-12 items-start">
          
          {/* جهة اليمين: تفاصيل الخدمة وقنوات التواصل */}
          <div className="space-y-8">
            
            <div className="space-y-5 text-right bg-white/80 backdrop-blur-md p-6 sm:p-8 rounded-[2rem] border border-white shadow-[0_20px_40px_-15px_rgba(0,0,0,0.03)]">
              
              <div className="inline-flex items-center gap-1.5 bg-[#004aad]/5 text-[#004aad] border border-[#004aad]/10 px-3 py-1 rounded-full text-[10px] font-black tracking-wide mb-1">
                <Sparkles className="w-3 h-3 text-[#00d2ff] animate-pulse" />
                <span>حلول دفع ذكية وسريعة</span>
              </div>

              <h3 className="text-3xl md:text-4xl font-black text-[#004aad] tracking-wide flex items-center gap-3">
                <span>ميني ماني</span>
                <span className="text-gray-300 font-light text-2xl md:text-3xl">|</span>
                <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-l from-[#004aad] to-cyan-500 font-mono tracking-tight">Mini Money</span>
              </h3>
              
              <div className="w-full h-[2px] bg-gradient-to-r from-[#004aad]/20 via-gray-100 to-transparent rounded-full my-4" />
              
              <p className="text-gray-600 text-base md:text-lg leading-relaxed font-medium">
                نظام تقسيط متطور يمنحك المرونة الكاملة لشراء كافة احتياجاتك من أجهزة <span className="font-bold text-gray-900">"LaserJet"</span> الإلكترونية والمنزلية، مع فترات سداد ميسرة تناسب ميزانيتك وتسهل تعاملاتك اليومية تجربة دفع وسداد آمنة وسريعة لضمان البقاء على تواصل دائم وبأعلى كفاءة.
              </p>

              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="flex items-center gap-2 text-sm font-bold text-[#004aad] hover:text-cyan-600 transition-colors mt-2 focus:outline-none group/toggle"
              >
                <span>{isExpanded ? "عرض تفاصيل أقل" : "عرض المزيد من المميزات وخطط السداد"}</span>
                {isExpanded ? (
                  <ChevronUp className="w-4 h-4 transition-transform group-hover/toggle:-translate-y-0.5" />
                ) : (
                  <ChevronDown className="w-4 h-4 transition-transform group-hover/toggle:translate-y-0.5" />
                )}
              </button>

              <AnimatePresence initial={false}>
                {isExpanded && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="overflow-hidden space-y-6 pt-2"
                  >
                    <div className="space-y-3">
                      <h4 className="text-md font-bold text-gray-900 border-r-2 border-cyan-500 pr-2">مميزات خدمة "ميني ماني"</h4>
                      <div className="grid grid-cols-1 gap-2.5">
                        {features.map((feat, idx) => (
                          <div key={idx} className="flex items-start gap-2.5 bg-slate-50/80 p-3 rounded-xl border border-slate-100">
                            <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" />
                            <div>
                              <p className="text-sm font-bold text-gray-800">{feat.title}</p>
                              <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{feat.desc}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="space-y-3">
                      <h4 className="text-md font-bold text-gray-900 border-r-2 border-cyan-500 pr-2">خطط السداد المتاحة</h4>
                      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
                        {installmentPlans.map((plan, idx) => (
                          <div key={idx} className="flex flex-col items-center justify-center p-2.5 bg-white border border-gray-100 rounded-xl shadow-sm text-center">
                            <Calendar className="w-4 h-4 text-[#004aad] mb-1" />
                            <span className="text-xs font-bold text-gray-700">{plan}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              <div className="pt-2">
                <a 
                  href="https://minimoney.laserjet.com.eg" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-bold text-white transition-all duration-300 group/btn bg-[#004aad] hover:bg-cyan-600 px-6 py-3 rounded-xl shadow-[0_10px_25px_-10px_rgba(0,74,173,0.4)]"
                >
                  <span>اذهب للموقع الإلكتروني</span>
                  <ArrowLeft className="w-4 h-4 transition-transform duration-300 group-hover/btn:-translate-x-1" />
                </a>
              </div>
            </div>

            {/* كروت الروابط السريعة */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {contactLinks.map((item) => (
  <a
    key={item.id}
    href={item.href}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-4 p-4 rounded-2xl bg-white border border-slate-100 text-gray-800 hover:border-[#004aad]/30 hover:shadow-[0_15px_30px_rgba(0,74,173,0.03)] transition-all duration-300 group/item"
  >
    {/* 1. السهم بقى في الأول */}
    <ArrowUpLeft className="w-4 h-4 text-gray-300 group-hover/item:text-[#004aad] group-hover/item:-translate-x-0.5 group-hover/item:-translate-y-0.5 transition-all shrink-0" />
    
    {/* 2. الكلام في النص */}
    <div className="text-right overflow-hidden flex-1">
      <p className="text-xs text-gray-400 font-medium mb-0.5">{item.label}</p>
      <p className="text-sm font-bold text-gray-800 truncate tracking-wide text-left" dir="ltr">{item.value}</p>
    </div>

    {/* 3. الأيقونة بقت في الآخر وأخدت ml-auto عشان تحافظ على المسافة */}
    <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center shrink-0 group-hover/item:bg-[#004aad]/5 transition-colors ml-auto">
      {item.icon}
    </div>
  </a>
))}
            </div>

            {/* منصات السوشيال ميديا */}
            <div className="p-5 rounded-2xl bg-white border border-slate-100 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <h4 className="text-sm font-bold text-gray-700">تابعنا على منصاتنا الرسمية:</h4>
              <div className="flex flex-wrap gap-2.5">
                {socialLinks.map((social) => (
                  <a
                    key={social.id}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.name}
                    className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:-translate-y-0.5 shadow-sm border ${social.color}`}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

          </div>

          {/* جهة اليسار: الصورة و أزرار التحميل */}
          <div className="w-full flex flex-col items-center lg:items-end lg:sticky lg:top-24 gap-6">
            
            {/* الديف الخارجي محتفظ بتصميمه الدائري لحماية أبعاد المساحة */}
            <div className="w-[280px] h-[280px] sm:w-[440px] sm:h-[440px] rounded-full overflow-hidden relative shadow-[0_30px_60px_-20px_rgba(0,0,0,0.06)] border border-white group/card bg-white flex items-center justify-center">
              
              {/* 🛠 الصورة نفسها تم جعلها دائرية تماماً من خلال rounded-full و object-cover مع p-2 لترك مسافة بوردر أنيقة */}
              <img 
                src="/mmoney.png" 
                alt="LaserJet Service Display" 
                className="absolute inset-0 w-full h-full object-cover rounded-full aspect-square z-0 transition-transform duration-700 ease-out group-hover/card:scale-103 select-none pointer-events-none p-2"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/10 via-transparent to-transparent z-10 pointer-events-none rounded-full" />
              
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-xl text-[#004aad] font-black text-[10px] sm:text-xs border border-white/50 shadow-sm whitespace-nowrap">
                LaserJet Premium Service
              </div>
            </div>

            {/* أزرار المتاجر الرقمية */}
            <div className="w-full max-w-[500px] grid grid-cols-2 gap-4">
              
              <a 
                href="https://play.google.com/store/apps/details?id=com.laserjet" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 p-3 rounded-2xl bg-gray-900 text-white border border-gray-800 hover:bg-gray-800 transition-all duration-300 shadow-sm transform hover:-translate-y-0.5 group/store"
              >
                <FaGooglePlay className="w-6 h-6 text-white group-hover/store:text-cyan-400 transition-colors" />
                <div className="text-right">
                  <p className="text-[10px] text-gray-400 block font-medium leading-none mb-1">تحميل من متجر</p>
                  <p className="text-sm font-bold leading-none font-sans">Google Play</p>
                </div>
              </a>

              <a 
                href="https://play.google.com/store/apps/details?id=com.laserjet" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 p-3 rounded-2xl bg-gray-900 text-white border border-gray-800 hover:bg-gray-800 transition-all duration-300 shadow-sm transform hover:-translate-y-0.5 group/store"
              >
                <FaApple className="w-6 h-6 text-white group-hover/store:text-cyan-400 transition-colors" />
                <div className="text-right">
                  <p className="text-[10px] text-gray-400 block font-medium leading-none mb-1">تحميل من متجر</p>
                  <p className="text-sm font-bold leading-none font-sans">App Store</p>
                </div>
              </a>

            </div>

          </div>

        </div>

      </div>
                    
    </motion.section>
  );
}